import { SchemaFactory } from 'fluid-framework';
import { TreeReference } from './TreeReference.js';
const schemaFactory = new SchemaFactory('datapad.player');
const sharedUserProps = {
    id: schemaFactory.identifier,
    userName: schemaFactory.string,
};
export class GameMaster extends schemaFactory.object('game-master', sharedUserProps) {
}
export class Player extends schemaFactory.object('player', {
    ...sharedUserProps,
    characters: schemaFactory.array(TreeReference),
    defaultCharacter: schemaFactory.optional(TreeReference),
}) {
}
export const User = [GameMaster, Player];
//# sourceMappingURL=User.js.map